export function isAppRouteRoute(route) {
    return route.endsWith("/route");
}

//# sourceMappingURL=is-app-route-route.js.map